import React, { useEffect, useRef } from 'react'
import { View } from 'react-native'
import { useDispatch } from 'react-redux'
import { RouteProp } from '@react-navigation/native'

import tw from 'tailwind-rn'
import { StackNavigationProp } from '@react-navigation/stack'
import ActionCreators from '../../store/actions'
import { RootStackParamList } from '../../navigators/AppNavigator'
import styles from './styles'
import { HGView } from '../../components/HGUI'
import SignUpSecondScreenForm, {
  SignUpSecondStepValues,
} from './SignUpSecondScreenForm'
import errors from '../../config/error'
import HansGretelLogo from './HansGretelLogo'

type Props = {
  navigation: StackNavigationProp<RootStackParamList, 'SignUpSecond'>
  route: RouteProp<RootStackParamList, 'SignUpSecond'>
}

const SignUpSecondScreen = (props: Props) => {
  const {
    route: {
      params: { registrationCode },
    },
    navigation,
  } = props
  const dispatch = useDispatch()
  const registerAccountForm = useRef(null)

  const handleFormSubmit = async (
    values: SignUpSecondStepValues,
    setSubmitting: (value: boolean) => void,
    setStatus: (status: string) => void
  ) => {
    const { username, password } = values

    if (
      !registrationCode.length ||
      !username.length ||
      !password.length ||
      !registerAccountForm
    )
      return false

    try {
      setSubmitting(true)
      await dispatch(
        ActionCreators.registerUser({ username, password, registrationCode })
      )
    } catch (errorResults) {
      const responseError =
        errorResults && errorResults[0] && errorResults[0].message === 'User already exists.'
          ? 'auth/email-already-in-use'
          : 'auth/registration-data-invalid'

      setStatus(errors[responseError].message)

      dispatch(
        ActionCreators.handleError({
          code: responseError,
        })
      )
    } finally {
      setSubmitting(false)
    }
  }

  useEffect(() => {
    if (!navigation.canGoBack()) {
      navigation.reset({
        index: 1,
        routes: [
          { name: 'Onboarding' },
          {
            name: 'SignUpSecond',
            params: {
              registrationCode,
            },
          },
        ],
      })
    }
  }, [])

  return (
    <HGView style={styles.centerWrap}>
      <View style={tw('mb-8')}>
        <HansGretelLogo />
      </View>

      <View style={styles.centerWrapInner}>
        <SignUpSecondScreenForm onSubmit={handleFormSubmit} />
      </View>
    </HGView>
  )
}

export default SignUpSecondScreen
